import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_RECURRING_RULES',
  'CREATE_RECURRING_RULE',
  'UPDATE_RECURRING_RULE',
  'DELETE_RECURRING_RULE',
  'GET_AUTOMATED_ORDERS'
);
